import { render, staticRenderFns } from "./EditarFornecedor.vue?vue&type=template&id=99ecda88&lang=pug"
import script from "./EditarFornecedor.vue?vue&type=script&lang=js"
export * from "./EditarFornecedor.vue?vue&type=script&lang=js"
import style0 from "./EditarFornecedor.vue?vue&type=style&index=0&id=99ecda88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports